import React, { useEffect, useState } from "react";
import { winnerList, winnerListProps } from "./apis/winner";

interface WinnersModalProps {
  onClose: () => void;
  showWinners?: boolean;
}

const PlayerRow: React.FC<{ player: winnerListProps; index: number }> = ({
  player,
  index,
}) => {
  const getCrownClass = () => {
    return index === 0 ? "text-yellow-400" : "text-gray-300";
  };

  return (
    <div
      style={{ backgroundImage: `url('/assets/winnerUserBg.png')` }}
      className="flex items-center w-full h- justify-between px-4 mt-3 py-2  rounded-lg"
    >
      <span className={`mr-1 ${getCrownClass()}`}>
        <img src="/assets/crone.png" alt="crone" width={25} height={25} />
      </span>
      <img
        src="/assets/user.png"
        alt="user"
        width={35}
        height={35}
        className="px-1"
      />
      <span className="flex-1 text-white text-sm">{player.username}</span>
      {/* <span className="text-yellow-400  gap-x-1 flex items-center pr-10 text-sm"><img src="/assets/cup3.png" alt="cup" className="w-[22px] h-[22px]" />{player.multiplier}</span> */}
      <div className=" text-sm flex justify-center items-cneter">
        {/* <img src='/assets/cup1.png' width={60} height={60} alt='trophy'/> */}
        <img src="/assets/coin.png" alt="coin" width={28} height={15} />
        <span className=" text-white text-[12px] font-bold  p-1  ">
          {player.total_prize_win}
        </span>
      </div>
    </div>
  );
};

const WinnersPopup: React.FC<WinnersModalProps> = ({
  onClose,
  showWinners,
}) => {
  const [winners, setWinner] = useState<winnerListProps[]>();

  useEffect(() => {
    const getWinners = async () => {
      const data = await winnerList();
      setWinner(data);
    };
    getWinners();
  }, [showWinners]);

  return (
    <>


      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="absolute inset-0 bg-black bg-opacity-50" />

        <div className="relative bg-transparent lg:max-w-[400px] 2xl:max-w-[500px] w-auto h-auto  flex flex-col items-center justify-center">
          <img
            src={'/assets/winnersBg.png'}
            alt="Popup Background"
            className="w-full h-full object-contain"
          />

          <img
            src={'/assets/winners.png'}
            alt="Winners"
            className="absolute top-[25px] md:w-[350px] md:h-[110px] w-[250px]"
            style={{ transform: 'translateY(-50%)' }}
          />

          <div
            className="absolute top-[30px] right-[30px] w-8 h-8 flex items-center justify-center bg-blue-700 rounded-full cursor-pointer"
            onClick={onClose}
          >
            <span className="text-white text-xl">×</span>
          </div>

          <div className="absolute top-[42px] w-[90%] px-4 h-[300px] xl:h-[400px] py-4 overflow-y-auto custom-scrollbar max-w-[450px]">
            {winners &&
              winners.map((player, index) => (
                <PlayerRow key={index} player={player} index={index} />
              ))}
          </div>

          <button
            onClick={onClose}
            className="absolute text-white bottom-2 w-[145px] h-[50px]"
            style={{
              backgroundImage: `url(${'/assets/blueButton.png'})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            Go Back
          </button>
        </div>
      </div>

    </>
  );
};

export default WinnersPopup;
